var HyperLinkSupport = require("enyo-ui/HyperLinkSupport"),
    IconButton       = require("app/ui/IconButton"),
    Layout           = require("./HeaderContentLayout"),
    ShareButton      = require("app/Sharing/ShareButton"),
    TabBar           = require("./TabBar"),
    buttons          = require("app/theme/buttons"),
    frameThrottle    = require("enyo-perf/utils").frameThrottle,
    get              = require("object-path").get,
    icons            = require("app/theme/icons"),
    kind             = require("enyo/kind");

require("./HeaderContent.less");

module.exports = kind(/** @lends  app.HomePage.HeaderContent.prototype */ {

    /**
     * @private
     */
    name: "app.HomePage.HeaderContent",

    /**
     * @private
     */
    classes: "app-home-page-header-content",

    /**
     * @private
     */
    layoutKind: Layout,

    /**
     * Sets layout height. Can be used by other components to align content
     * below the metadata.
     *
     * @type {Object}
     * @readonly
     * @public
     */
    layoutMetrics: null,

    /**
     * The metrics from the header graphic layout.
     *
     * @readonly
     * @public
     */
    headerGraphicLayoutMetrics: null,

    /**
     * The state of this page.
     *
     * @type  {?Object}
     * @public
     */
    state: null,

    /**
     * @private
     */
    components: [{
        name:    "title",
        tag:     "h1",
        classes: "app-home-page-header-content__title"
    }, {
        name:    "secondaryTitle",
        tag:     "h2",
        classes: "app-home-page-header-content__secondary-title"
    }, {
        name:      "description",
        allowHtml: true,
        classes:   "app-home-page-header-content__description"
    }, {
        name:    "ctaButton",
        kind:    IconButton,
        classes: "app-home-page-header-content__cta-button",
        mixins:  [HyperLinkSupport],
        ontap:   "onHyperlinkTap",
        theme:   buttons["app.HomePage.HeaderContent.ctaButton"],
        icon:    icons["app.HomePage.HeaderContent.ctaButton"]
    }, {
        name:    "tabBar",
        kind:    TabBar,
        classes: "app-home-page-header-content__tab-bar"
    }, {
        name:       "actionButtons",
        classes:    "app-home-page-header-content__action-buttons",
        components: [{
            name:    "shareButton",
            kind:    ShareButton,
            classes: "app-home-page-action-buttons__button",
            theme:   buttons["app.HomePage.HeaderContent.shareButton"]
        }]
    }],

    /**
     * @private
     */
    bindings: [{
        from: ".state",
        to:   ".$.tabBar.state"
    }],

    /**
     * @private
     */
    observers: {
        lazyResize:      ["headerGraphicLayoutMetrics"],
        updateAndResize: ["state"]
    },

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            this.lazyResize      = frameThrottle(this.bindSafely(this.resize));
            this.updateAndResize = frameThrottle(this.bindSafely(this.updateAndResize));
            sup.apply(this, arguments);
            this.observe("$.shareButton.showing", this.lazyResize);
            this.updateAndResize();
        };
    }),

    /**
     * This component needs to resize after it's been updated, but we want the
     * update function to be extensible. This method allows us to resize after
     * all updates are done.
     *
     * @private
     */
    updateAndResize: function() {
        this.update();
        this.resize();
    },

    /**
     * @protected
     */
    update: function() {
        var state      = this.state || {},
            $ctaButton = this.$.ctaButton;

        this.$.title.set("content", get(state, "data.meta.title", null) || "");

        this.$.secondaryTitle.set("content", get(state, "data.meta.secondary_title", null) || "");

        this.$.description.set("content", get(state, "data.meta.html_short_description", null) || "");

        $ctaButton.set("caption", get(state, "data.meta.call_to_action_text", null) || "");
        $ctaButton.set("href", get(state, "data.meta.call_to_action_url", null));

        this.$.shareButton.set("mediaItem", get(state, "data", null));
    }

});
